import React, { Fragment, useEffect, useState } from "react";
import {
  deleteLinking,
  disableLinking,
  getLinkedStandards,
} from "../../../api/standardLinking.service";
import { UnlinkIcon } from "../../../assets/icons";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import { OneWayLinkIcon, TwoWayLinkIcon } from "../../../assets/icons/index";
import Constant from "../../../utils/constant";
import ConfirmationPopup from "../../shared/common/confirmationPopup";
import Loader from "../../shared/loader/loader";
import { useNavigate } from "react-router";

interface ExistingLinkingProps {
  standardId: number;
  userId: number;
}

function ExistingLinking(props: ExistingLinkingProps) {
  const { userId, standardId } = props;
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const [selectedStandards, setSelectedStandards] = useState<number[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [deleteLinkingId, setDeleteLinkingId] = useState<number>();
  const [deleteLinkingName, setDeleteLinkingName] = useState<string>("");
  const [enableBulkUnlink, setEnableBulkUnlink] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  function bindLinkedStandard() {
    getLinkedStandards(standardId).then((response) => {
      unCheckAll();
      setLinkedStandards(response.data);
    });
  }

  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const checked = e.target.checked;
    const currentItems = selectedStandards;
    if (checked) {
      currentItems.push(id);
    } else {
      const itemIndex = currentItems.indexOf(id);
      currentItems.splice(itemIndex, 1);
    }
    currentItems.length > 0
      ? setEnableBulkUnlink(true)
      : setEnableBulkUnlink(false);
    setSelectedStandards(currentItems);
  };

  function handleDeleteConfimation(confirmAction: boolean) {
    setShowConfirmation(false);
    setLoading(true);
    if (confirmAction) {
      if (deleteLinkingId) {
        deleteLinking(userId, standardId, deleteLinkingId.toString()).then(
          () => {
            setLoading(false);
            bindLinkedStandard();
          }
        );
      } else {
        setLoading(false);
        handleDelete();
      }
    }
    setDeleteLinkingId(undefined);
  }

  function handleDelete() {
    setLoading(true);
    deleteLinking(userId, standardId, selectedStandards.join(",")).then(() => {
      setSelectedStandards([]);
      bindLinkedStandard();

      setLoading(false);
    });
  }

  function handleSingleDelete(id: number, name: string) {
    setShowConfirmation(true);
    setDeleteLinkingId(id);
    setDeleteLinkingName(name);
  }

  useEffect(() => {
    bindLinkedStandard();
  }, []);
  const handleRedirect = (
    objectType: string,
    objectId: string,
    subjectType?: number
  ) => {
    if (objectType === "QuestionId" || objectType === "QuestionText") {
      navigate(Constant.MANAGEQUESTION.replace(":id", objectId), {
        state: { questionIdToEdit: objectId },
      });
    } else if (objectType === "Subject") {
      if (subjectType === Constant.SubjectType.LO) {
        navigate(
          Constant.LIFTOFFSUBJECTEDIT.replace(":id", objectId.toString()),
          { state: { subjectType } }
        );
      } else if (objectId) {
        navigate(Constant.SUBJECTDETAIL.replace(":id", objectId.toString()), {
          state: { subjectType },
        });
      } else {
        navigate(Constant.ADDSUBJECT);
      }
    } else if (objectType === "Domain") {
      navigate(Constant.EDITDOMAIN.replace(":id", objectId));
    } else if (objectType === "Standard") {
      navigate(Constant.EDITSTANDARD.replace(":id", objectId));
    }
  };
  const unCheckAll = () => {
    [...document.querySelectorAll("#isActive")].map((input: any) => {
      if (input.checked) {
        input.checked = !input.checked;
      }
      return null;
    });
  };
  return (
    <Fragment>
      {loading && <Loader />}

      {showConfirmation && (
        <ConfirmationPopup
          title={"Unlink Standard"}
          confirmAction={handleDeleteConfimation}
          message={`Are you sure you want to unlink ${deleteLinkingName}? `}
          buttonText={"Yes"}
        />
      )}
      <div className=" overflow-hidden border-b border-gray-200 sm:rounded-lg mt-16 mb-20 ">
        <div
          className={`flex items-center justify-end mb-3 ${
            enableBulkUnlink ? "" : "cursor-not-allowed"
          }`}
        >
          <button
            onClick={() => setShowConfirmation(true)}
            className="mt-4 py-1.5 px-2 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
          >
            <UnlinkIcon />
            Group Unlink
          </button>
        </div>
        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-primary-color">
              <tr>
                <th
                  scope="col"
                  className="inline-flex items-center whitespace-nowrap px-3 py-2 font-light text-sm text-center text-white w-5"
                />

                <th
                  scope="col"
                  className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                >
                  <span className="flex">Linking</span>
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 whitespace-nowrap text-center font-light text-sm text-center text-white tracking-wider"
                >
                  <span className="flex">State</span>
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                >
                  <span className="flex">Subject</span>
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                >
                  <span className="flex">Domain</span>
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                >
                  <span className="flex">Standard</span>
                </th>
                <th
                  scope="col"
                  className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white tracking-wider"
                >
                  <span className="flex">Questions</span>
                </th>

                <th
                  scope="col"
                  className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white tracking-wider w-12"
                >
                  <span className="flex">Unlink</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {linkedStandards &&
                linkedStandards.length > 0 &&
                linkedStandards.map((linkedStandard, index) => {
                  return (
                    <tr key={index} className="bg-white">
                      <td className="px-3 py-2 text-sm text-left font-normal text-gray-500 w-5">
                        <div className="flex flex-row items-center ">
                          <input
                            id="isActive"
                            name="isActive"
                            type="checkbox"
                            className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                            onChange={(e) =>
                              handleOnChange(
                                e,
                                linkedStandard.destinationStandardId
                              )
                            }
                          />
                        </div>
                      </td>
                      <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500">
                        {linkedStandard.linkingType ===
                        Constant.StandardLinkingType.ONEWAY ? (
                          <OneWayLinkIcon />
                        ) : (
                          <TwoWayLinkIcon />
                        )}
                      </td>
                      <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                        {linkedStandard.state}
                      </td>
                      <td className="px-3  py-2 capitalize text-sm font-normal text-gray-500">
                        <a
                          href={Constant.SUBJECTDETAIL.replace(
                            ":id",
                            linkedStandard?.subjectId?.toString()
                          )}
                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                          onClick={(e) => {
                            handleRedirect(
                              "Subject",
                              linkedStandard?.subjectId?.toString(),
                              linkedStandard.subjectTypeId
                            );
                          }}
                        >
                          {linkedStandard.subject}
                        </a>
                      </td>
                      <td className="px-3 whitespace-nowrap text-sm font-normal text-gray-500">
                        <a
                          href={Constant.EDITDOMAIN.replace(
                            ":id",
                            linkedStandard?.domainId?.toString()
                          )}
                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                          onClick={(e) => {
                            handleRedirect(
                              "Domain",
                              linkedStandard?.domainId?.toString()
                            );
                          }}
                        >
                          {linkedStandard.domain}
                        </a>
                      </td>
                      <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                        <a
                          href={Constant.EDITSTANDARD.replace(
                            ":id",
                            linkedStandard?.destinationStandardId?.toString()
                          )}
                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                          onClick={(e) => {
                            handleRedirect(
                              "Standard",
                              linkedStandard?.destinationStandardId?.toString()
                            );
                          }}
                        >
                          {`[${linkedStandard.code}] ${linkedStandard.name}`}
                        </a>
                      </td>
                      <td className="px-3  text-sm font-normal text-gray-500">
                        {linkedStandard.totalQuestions}
                      </td>

                      <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                        <a
                          onClick={() =>
                            handleSingleDelete(
                              linkedStandard.destinationStandardId,
                              linkedStandard.name
                            )
                          }
                          href="#"
                          className="hover:text-primary-color mx-auto inline-block"
                        >
                          <UnlinkIcon />
                        </a>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        {linkedStandards && linkedStandards.length === 0 && (
          <div className="flex justify-between items-center">
            <p className="p-2">No Records Found</p>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default ExistingLinking;
